import React from 'react';
import './Video.styles.scss';

interface VideoProps {
  videoID: string;
  platform: 'youtube' | 'vimeo';
  className?: string;
}

const Video: React.FC<VideoProps> = ({ videoID, platform, className }) => {
  return (
    <div className={`video-wrapper ${className || ''}`}>
      {platform === 'youtube' && (
        <iframe
          src={`https://www.youtube.com/embed/${videoID}`}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      )}
      {platform === 'vimeo' && (
        <>
          <iframe
            src={`https://player.vimeo.com/video/${videoID}?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479`}
            title="Vimeo video player"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
          />
          <script src="https://player.vimeo.com/api/player.js"></script>
        </>
      )}
    </div>
  );
};

export default Video;
